<template>
  <v-select
    v-model="original"
    :label="label"
    :items="items"
    :item-text="itemText"
    :item-value="itemValue"
    :rules="rules"
    :required="required"
    :solo="solo"
    :no-data-text="noDataText"
  ></v-select>
</template>

<script>
export default {
  name: 'SendersOrMessageTypes',
  props: {
    label: { type: String },
    itemText: { type: String },
    itemValue: { type: String },
    noDataText: { type: String },
    default: { default: () => '' },
    rules: { default: () => [] },
    required: { default: () => false },
    solo: { default: () => false },
    items: {},
  },
  created() {
    this.$emit('on:model-update', this.default);
  },
  data: () => ({ org: {} }),
  computed: {
    original: {
      get() {
        if (this.default !== '') {
          return this.default;
        }
        return this.org;
      },
      set(v) {
        this.org = v;
      },
    },
  },
  watch: {
    org(nv) {
      this.$emit('on:model-update', nv);
    },
  },
};
</script>
